import type { CSSProperties } from "react";

import { countGraphemes } from "@/lib/motion";

/** What {@link typewriterProps} spreads onto an existing semantic text element. */
export type TypewriterProps = {
  "data-busee-typewriter": "";
  style: CSSProperties;
};

/**
 * Adds a presentation-only typewriter reveal to an element that already owns
 * its text and semantics.
 *
 * ```tsx
 * <h1 {...typewriterProps(title)}>{title}</h1>
 * <p {...typewriterProps(summary)}>{summary}</p>
 * ```
 *
 * The caller renders the complete string once. That reserves its final layout,
 * leaves it available to screen readers immediately, and avoids timers or a
 * DOM node for every character. The returned props add no wrapper, so they are
 * safe on a direct child of a flex or grid layout.
 */
export function typewriterProps(text: string, style: CSSProperties = {}): TypewriterProps {
  return {
    "data-busee-typewriter": "",
    style: {
      ...style,
      "--busee-typewriter-steps": Math.max(1, countGraphemes(text)),
    } as CSSProperties,
  };
}
